// JS
import React, { useEffect, useState } from 'react';
import { randomId } from '../shared/utils';

// COMPONENTS
import Product from '../Product';
import Button from '../Button';
import { Skeleton } from '../Ui/skeleton';

// COMPONENT
const BrandStory = ({
  brandStoryData,
  brandStoryFeed,
  gaBlockName,
  showBrandStory = true,
  brandStoryOptions
}) => {
  const uniqueId = randomId();
  const [data, setData] = useState(brandStoryFeed);

  // API DATA
  useEffect(() => {
    if (brandStoryFeed && brandStoryFeed.data) {
      setData(brandStoryFeed.data.products.products);
    }
  }, [brandStoryFeed]);

  return (
    <section
      id={'brand-story-section-' + uniqueId}
      className={
        showBrandStory
          ? 'container my-24 lg:my-48 w-100' +
            (brandStoryOptions?.classes ? ' ' + brandStoryOptions.classes : '')
          : 'hidden'
      }
    >
      {brandStoryData ? (
        brandStoryData.map((item, i) => {
          return (
            <React.Fragment key={i}>
              <div
                data-name={item.block_title}
                data-creative={gaBlockName}
                data-id={item.contentguid}
                data-position={'banner-slot-' + (i + 1)}
                data-type="banner"
                className="flex flex-col gap-x-6 md:pt-5 md:flex-row"
              >
                <div className="w-full flex flex-col justify-between md:w-6/12">
                  <div className="pb-5 text-xl text-left uppercase md:pb-0">
                    <h2 className="font-bold">{item.block_title}</h2>
                    <p className="font-base text-lg">{item.block_sub_title}</p>
                  </div>
                  <a
                    key={item.contentguid}
                    href={item.url}
                    alt={'brand-image-' + item.block_title}
                    className="flex items-end w-full h-5/6 aspect-[9/8] md:aspect-[9/3] bg-cover bg-center bg-no-repeat"
                    style={{
                      backgroundImage: `url(${item.icon})`
                    }}
                    data-name={item.block_title}
                    data-creative={gaBlockName}
                    data-id={item.contentguid}
                    data-position={'button-slot-' + (i + 1)}
                    data-type="banner-button"
                  />
                </div>
                <div className="w-full md:w-6/12">
                  {data &&
                    data.map((slide, i) => (
                      <Product
                        key={'product-key-' + uniqueId}
                        gaBlockName={gaBlockName}
                        productID={slide.product.productid}
                        productURL={slide.product.url}
                        productName={slide.product.name}
                        productPosition={i + 1}
                        productCategory={
                          slide.product.attributes.product_category
                        }
                        productBrand={slide.product.attributes.brand}
                        productImage={slide.product.image}
                        // Change to '.alternatives[2]' from '.alternative' for different alternative image
                        productImageAlternate={
                          slide.product.attributes.alternative
                        }
                        productPrice={slide.product.option.price}
                        productPromotionPrice={
                          slide.product.option.promotionprice
                        }
                        productAspectOptions={{
                          classes: 'lg:aspect-h-7'
                        }}
                        productObjectOptions={{
                          classes: '!object-contain'
                        }}
                        button={
                          <Button
                            buttonColour="black"
                            buttonLink={slide.product.url}
                            buttonLinkText={item.link_label}
                            buttonAdditionalClasses={{
                              classes: 'mt-7 md:mt-0'
                            }}
                            gaBlockTitle={item.link_label}
                            gaBlockName={gaBlockName}
                            gaBlockId={item.contentguid}
                          />
                        }
                        prodWidth={false}
                      />
                    ))}
                </div>
              </div>
            </React.Fragment>
          );
        })
      ) : (
        <div className="w-full h-[1100px] md:h-[450px] xl:h-[550px] 2xl:h-[650px] grid md:gap-5 md:grid-cols-2">
          <Skeleton className="aspect-square h-full" />
          <Skeleton className="aspect-square h-full" />
        </div>
      )}
    </section>
  );
};

export default BrandStory;
